import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Format extends BasicEntity {
code: string;
dataKind: string;
description: TranslatedEmb;
label: TranslatedEmb;
regExp: string;
}

